import React from 'react'
import { ArticlesContext, ArticlesContextInterface } from './ArticlesContext'

export const withArticlesContext = <P extends object>(Component: React.ComponentType<P>) => {
  return function ComponentWrappedWithArticles(props: Pick<P, Exclude<keyof P, keyof ArticlesContextInterface>>) {
    return (
      <ArticlesContext.Consumer>
        {(context: ArticlesContextInterface) => <Component {...(props as P)} {...context} />}
      </ArticlesContext.Consumer>
    )
  }
}
